import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { SortDescriptor, State, FilterDescriptor } from '@progress/kendo-data-query';

// interface Item {
//   id: number;
//   nombre: string;  
// }

@Component({
  selector: 'catalog-multiselect',
  template: `
    <kendo-multiselect [data]="_list" 
      [value]="selectedItems"
      [textField]="textField"
      [valueField]="valueField"      
      [placeholder]=""
      [readonly]="readonly"
      (valueChange)="valueChange($event)">
      <ng-template kendoMultiSelectTagTemplate let-dataItem>
        <span class="k-icon {{ (iconField != '__ICON__') ? dataItem[iconField] : 'k-i-circle' }}"></span> {{ dataItem[textField] }}
      </ng-template>
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <!--<input type="checkbox" class="k-checkbox" [checked]="isItemSelected(dataItem.text)"/>-->
        <span class="k-icon {{ (iconField != '__ICON__') ? dataItem[iconField] : 'k-i-circle' }}"></span> {{ dataItem[textField] }}
      </ng-template>
    </kendo-multiselect>`,
  styles: [``],
})
export class CatalogMultiselectComponent {
  
  //Input: table
  private _table : string = '__TABLE__';

  @Input()
  set table(value: string) {
    this._table = (value && value.trim());
    // console.log('set table = ' + this._table);
  }

  get table(): string { return this._table; }

  //Input: valueField
  private _valueField : string = '__ID__';

  @Input()
  set valueField(value: string) {
    this._valueField = (value && value.trim());
    // console.log('set valueField = ' + this._valueField);
  }

  get valueField(): string { return this._valueField; }

  //Input: textField
  private _textField : string = '__NAME__';

  @Input()
  set textField(value: string) {
    this._textField = (value && value.trim());
    // console.log('set textField = ' + this._textField);
  }

  get textField(): string { return this._textField; }

  //Input: iconField
  private _iconField : string = '__ICON__';

  @Input()
  set iconField(value: string) {
    this._iconField = (value && value.trim());
    // console.log('set iconField = ' + this._iconField);
  }

  get iconField(): string { return this._iconField; }

  //Input: sortField
  private _sortField : string = 'asc';

  @Input()
  set sortField(value: string) {
    this._sortField = (value && value.trim());
    // console.log('set sortField = ' + this._sortField);
  }

  get sortField(): string { return this._sortField; }

  //Input: showAll
  private _showAll: boolean = false;

  @Input()
  set showAll(value: boolean) {
    this._showAll = value;
    // console.log('set showAll = ' + this._showAll);
  }

  get showAll(): boolean { return this._showAll; }

  @Input() extraFilter : FilterDescriptor[] = [];

  //Input: selectedValues
  private _selectedValues : string = '';

  @Input()
  set selectedValues(value: string) {
    this._selectedValues = value;
    console.log('set selectedValues = ' + this._selectedValues);
    this.tryReadData()
  }

  get selectedValues(): string { return this._selectedValues; }

  // @Input() values: string = "";
  @Input() readonly: boolean = false;

  private _filter: string = ''; 

  private _list: Array<any> = [];

  private _selectedItems: Array<any> = [];

  get selectedItems(): Array<any> { return this._selectedItems; }

  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private service: DatasourceService) { 
    
  }

  protected getItemsString() : string {

    let field = this._valueField;
    return this._selectedItems.map(v => v[field]).join(",");

  }

  protected getState(): State {

    let state: State = {
      // skip: 0, 
      take: (this._showAll) ? 0: 10, 
      sort: [
        {field: this._textField, dir: (this._sortField == 'asc') ? 'asc': 'desc'}
      ], 
      filter: {
        logic: "and",
        filters: []
      }, 
      //group: []
    }
    if(this.extraFilter != []){
      this.extraFilter.forEach(function(filter){
        state.filter.filters.push(filter);
      })
    }
    if(this._filter != ''){
      let filter: FilterDescriptor = {
        field: this._textField,
        operator: 'contains',
        value: this._filter
      }
      state.filter.filters.push(filter);
    }
    return state;

  };

  protected tryReadData() : void {

    console.log('FETCHING: TABLE[ ' + this._table + ' ] -> valueField: ' + this._valueField + ', textField: ' + this._textField + ', sortField: ' + this._sortField + ', showAll: ' + this._showAll + ', selectedValue: ' + this._selectedValues);

    this.service.getAll(this._table, this.getState(), (table, res)=>{
      this._list = res.data;
      this.updateSelectedItem();
    });

  }

  protected updateSelectedItem() : void {

    let list = this._list;
    let field = this._valueField;
    if(this._selectedValues != null && this._selectedValues != '' ){
      this._selectedItems = this._selectedValues.split(',').map(function(v){
        return list.find((i) => i[field] == v);
      });
    };

    //Emitir evento: selected
    this.selected.emit({items: this._selectedItems, itemsString: this.getItemsString()});
    console.log('valueChange', this._selectedItems);

  }
 
  protected valueChange(values: any): void {

    this._selectedItems = values;
    this.selected.emit({items: this._selectedItems, itemsString: this.getItemsString()});
    console.log('valueChange', this._selectedItems);

  } 

}